export default  {
	name: 'Newsletter',
	methods: {
		submitForm() {
			setTimeout(() => {
				this.$refs.email_.value = "";
			}, 500);
		},
	},
}
